/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_EarlierInputs */

const id_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const ms_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const da_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const de_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const en_us2_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const es_es2_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteriores`)
};

const es_mx2_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const fil_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const fr_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const it_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const hu_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const nl_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const no_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const pl_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const pt_br2_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const pt_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const ro_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const fi_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const sv_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const vi_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const tr_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const cs_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const bg_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const ru_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раньше`)
};

const uk_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const ar_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const hi_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले`)
};

const th_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ก่อนหน้า`)
};

const ja_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const zh_cn2_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

const zh_hant1_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`較早`)
};

const ko_builds_timeline_earlier = /** @type {(inputs: Builds_Timeline_EarlierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier`)
};

/**
* | output |
* | --- |
* | "Earlier" |
*
* @param {Builds_Timeline_EarlierInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_earlier = /** @type {((inputs?: Builds_Timeline_EarlierInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_EarlierInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_earlier(inputs)
	if (locale === "ms") return ms_builds_timeline_earlier(inputs)
	if (locale === "da") return da_builds_timeline_earlier(inputs)
	if (locale === "de") return de_builds_timeline_earlier(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_earlier(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_earlier(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_earlier(inputs)
	if (locale === "fil") return fil_builds_timeline_earlier(inputs)
	if (locale === "fr") return fr_builds_timeline_earlier(inputs)
	if (locale === "it") return it_builds_timeline_earlier(inputs)
	if (locale === "hu") return hu_builds_timeline_earlier(inputs)
	if (locale === "nl") return nl_builds_timeline_earlier(inputs)
	if (locale === "no") return no_builds_timeline_earlier(inputs)
	if (locale === "pl") return pl_builds_timeline_earlier(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_earlier(inputs)
	if (locale === "pt") return pt_builds_timeline_earlier(inputs)
	if (locale === "ro") return ro_builds_timeline_earlier(inputs)
	if (locale === "fi") return fi_builds_timeline_earlier(inputs)
	if (locale === "sv") return sv_builds_timeline_earlier(inputs)
	if (locale === "vi") return vi_builds_timeline_earlier(inputs)
	if (locale === "tr") return tr_builds_timeline_earlier(inputs)
	if (locale === "cs") return cs_builds_timeline_earlier(inputs)
	if (locale === "bg") return bg_builds_timeline_earlier(inputs)
	if (locale === "ru") return ru_builds_timeline_earlier(inputs)
	if (locale === "uk") return uk_builds_timeline_earlier(inputs)
	if (locale === "ar") return ar_builds_timeline_earlier(inputs)
	if (locale === "hi") return hi_builds_timeline_earlier(inputs)
	if (locale === "th") return th_builds_timeline_earlier(inputs)
	if (locale === "ja") return ja_builds_timeline_earlier(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_earlier(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_earlier(inputs)
	return ko_builds_timeline_earlier(inputs)
});
export { builds_timeline_earlier as "builds.timeline.earlier" }